import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dl-device-input-host]'
})
export class DeviceInputHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
